import { KYMW1407Model } from '../kymw1407.model';
import { GetImageInfoDetailModel } from '../../kymw1400/vo/get-image-info-detail.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 画像情報詳細を取得する。
 *
 * @export
 * @class GetImageInfoDetailService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetImageInfoDetailService extends PlessJsonResponderSub<any> {

  private model: KYMW1407Model = null;
  private vo: GetImageInfoDetailModel = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetImageInfoDetailService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        ImageId: this.vo.imageId
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1407Model} model
   * @param {GetImageInfoDetailModel} vo
   * @memberof GetImageInfoDetailService
   */
  execute(model: KYMW1407Model, vo: GetImageInfoDetailModel) {
    this.model = model;
    this.vo = vo;
    this.send('KYMW14getImageInfoDetail', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetImageInfoDetailService
   */
  success(data: any) {
    this.model.updateImageInfoDetail(data);
  }
}
